import isEqual from 'lodash/isEqual';
import {FrameElements} from '../type/FrameElements.interface';
import {HtmlInfo} from '../type/HtmlInfo.interface';
import {TextViewerCoreOption} from '../type/TextViewerCoreOption.type';

export function checkShouldRedraw({
  frameElements,
  htmlInfo,
  prevHtmlInfo,
  option,
  prevOption,
  isPreview,
}:
  | {
      frameElements?: FrameElements | null;
      htmlInfo: HtmlInfo;
      prevHtmlInfo?: HtmlInfo;
      option: TextViewerCoreOption;
      prevOption?: TextViewerCoreOption;
      isPreview: false;
    }
  | {
      frameElements?: never;
      htmlInfo?: never;
      prevHtmlInfo?: never;
      option: TextViewerCoreOption;
      prevOption?: TextViewerCoreOption;
      isPreview: true;
    }) {
  if (isPreview) {
    return !isEqual(option, prevOption);
  }

  // 기존 정보가 유효하지 않다면 무조건 다시 그립니다.
  if (
    !frameElements ||
    !frameElements.contentElement.innerHTML ||
    !frameElements.settingStyleElement.innerHTML
  ) {
    return true;
  }

  // htmlInfo 정보가 변경되거나 option 정보가 변경되었다면 다시 그립니다.
  if (!isEqual(htmlInfo, prevHtmlInfo) || !isEqual(option, prevOption)) {
    return true;
  }

  return false;
}
